import { render, staticRenderFns } from "./BerkleyCommission.vue?vue&type=template&id=33e2e4c5"
import script from "./BerkleyCommission.vue?vue&type=script&lang=js"
export * from "./BerkleyCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports